// extracted by mini-css-extract-plugin
export default {"separador":"Separador_separador__fzk1-"};